/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetOrderVolumeForecastResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetOrderVolumeForecastResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { HistoryRequestBuilderRequestsMetadata, type HistoryRequestBuilder } from './history/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/forecasting/order-volume
 */
export interface OrderVolumeRequestBuilder extends BaseRequestBuilder<OrderVolumeRequestBuilder> {
    /**
     * The history property
     */
    get history(): HistoryRequestBuilder;
    /**
     * Projects total monthly order volume forward from the organisation's own sales history. A forecast needs two things, and says so differently when each is missing: sales history to seed it, and a trained model to extrapolate from. With no history at all the call returns 404. With history but no model it returns 400 naming the training endpoint to call — training is a separate, deliberate step, and this endpoint never trains one implicitly. Each predicted month feeds back into the next, so error compounds with distance: the horizon is clamped to 1–24 months and defaults to 12. Confidence bounds are 90% empirical intervals derived from the model's training residuals, and are omitted when the model recorded none. Train via POST /api/forecasting/models/order-volume/train, and pass modelId to pin the forecast to a version other than the current one.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetOrderVolumeForecastResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<OrderVolumeRequestBuilderGetQueryParameters> | undefined) : Promise<GetOrderVolumeForecastResponse | undefined>;
    /**
     * Projects total monthly order volume forward from the organisation's own sales history. A forecast needs two things, and says so differently when each is missing: sales history to seed it, and a trained model to extrapolate from. With no history at all the call returns 404. With history but no model it returns 400 naming the training endpoint to call — training is a separate, deliberate step, and this endpoint never trains one implicitly. Each predicted month feeds back into the next, so error compounds with distance: the horizon is clamped to 1–24 months and defaults to 12. Confidence bounds are 90% empirical intervals derived from the model's training residuals, and are omitted when the model recorded none. Train via POST /api/forecasting/models/order-volume/train, and pass modelId to pin the forecast to a version other than the current one.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<OrderVolumeRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Projects total monthly order volume forward from the organisation's own sales history. A forecast needs two things, and says so differently when each is missing: sales history to seed it, and a trained model to extrapolate from. With no history at all the call returns 404. With history but no model it returns 400 naming the training endpoint to call — training is a separate, deliberate step, and this endpoint never trains one implicitly. Each predicted month feeds back into the next, so error compounds with distance: the horizon is clamped to 1–24 months and defaults to 12. Confidence bounds are 90% empirical intervals derived from the model's training residuals, and are omitted when the model recorded none. Train via POST /api/forecasting/models/order-volume/train, and pass modelId to pin the forecast to a version other than the current one.
 */
export interface OrderVolumeRequestBuilderGetQueryParameters {
    /**
     * Number of months to forecast (1 – 24). Defaults to 12.
     */
    horizon?: number;
    /**
     * Optional: pin the forecast to a specific trained model version.When omitted the current active model is used.
     */
    modelId?: string;
}
/**
 * Uri template for the request builder.
 */
export const OrderVolumeRequestBuilderUriTemplate = "{+baseurl}/api/forecasting/order-volume?horizon={horizon}{&modelId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrderVolumeRequestBuilderNavigationMetadata: Record<Exclude<keyof OrderVolumeRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    history: {
        requestsMetadata: HistoryRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const OrderVolumeRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: OrderVolumeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetOrderVolumeForecastResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
